/**
 * Подбор предложения для стадии «применить».
 *
 * Предложения берутся из словаря естественных фраз: выдуманная конструкция
 * не тренирует реальный набор (ТЗ §4.6, §8.3). Поиск по словарю — задача
 * корпуса; здесь остаётся только правило режима: если подходящей фразы нет,
 * стадия «применить» для слова пропускается.
 */

import type { LanguageCode } from '@type2x/shared-contracts';
import { sentencesForWord } from '@type2x/corpora';

/** Естественное предложение со словом либо null. */
export function sentenceFor(language: LanguageCode, word: string): string | null {
  return sentencesForWord(language, word)[0]?.text ?? null;
}
